module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "device-item"
  }, [(_vm.recurrentServicesCount() > 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-2"
  }, [_vm._v("Ke službě:")]), _vm._v(" "), (!_vm.devmeta.isNew) ? _c('div', {
    staticClass: "col-md-9 col-lg-10"
  }, [_vm._v("\n      " + _vm._s(_vm.recurrentServiceDescription(_vm.devmeta.assignmentid)) + "\n    ")]) : _c('div', {
    staticClass: "col-md-9 col-lg-10"
  }, _vm._l((_vm.recurrentServicesInternet), function(service) {
    return _c('div', {
      key: service.id
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputAssignTo),
        expression: "inputAssignTo"
      }],
      attrs: {
        "type": "radio",
        "name": "assign_to"
      },
      domProps: {
        "value": service.id,
        "checked": _vm._q(_vm.inputAssignTo, service.id)
      },
      on: {
        "__c": function($event) {
          _vm.inputAssignTo = service.id
        }
      }
    }), _vm._v("\n          " + _vm._s(_vm.recurrentServiceDescription(service.id)) + "\n        ")])])
  }))]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "d-md-none"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-2"
  }, [_c('nobr', [_vm._v("MAC adresa:")])], 1), _vm._v(" "), (!_vm.isEditing) ? _c('div', {
    staticClass: "col-md-9 col-lg-10 device-item-highlight"
  }, [_vm._v(_vm._s(_vm.devmeta.mac) + "\n      "), (!_vm.$store.state.newMacDetected) ? _c('button', {
    staticClass: "btn btn-outline-primary btn-editmac",
    on: {
      "click": function($event) {
        _vm.startEdit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" změnit\n      ")]) : _c('button', {
    staticClass: "btn btn-primary btn-editmac",
    on: {
      "click": function($event) {
        _vm.startEdit(_vm.$store.state.newMacDetected)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" změnit na "), _c('span', {}, [_vm._v(_vm._s(_vm.$store.state.newMacDetected))])])]) : _vm._e(), _vm._v(" "), (_vm.isEditing) ? _c('div', {
    staticClass: "col-md-9 col-lg-10"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.noOp()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputMac),
      expression: "inputMac"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^([0-9a-f]{2}[:\- ]?){6}$/i
        }
      }),
      expression: "{ rules: { required: true, regex: /^([0-9a-f]{2}[:\\- ]?){6}$/i} }"
    }],
    ref: "mac",
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('mac')
    },
    attrs: {
      "type": "text",
      "name": "mac",
      "autocomplete": "off",
      "placeholder": "00:11:22:aa:bb:cc",
      "disabled": _vm.submitPending,
      "maxlength": "17"
    },
    domProps: {
      "value": (_vm.inputMac)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.inputMac = $event.target.value
      }, function($event) {
        _vm.editInput()
      }]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.errors.has('mac') || _vm.inputMac == '' || (_vm.devmeta.isNew && _vm.inputAssignTo == 0) || _vm.submitPending
    },
    on: {
      "click": function($event) {
        _vm.saveMac()
      }
    }
  }, [(!_vm.submitPending) ? _c('span', [_vm._v("uložit")]) : _c('span', [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger",
    attrs: {
      "disabled": _vm.submitPending,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.abortEdit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" zrušit\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mac')),
      expression: "errors.has('mac')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Vložte prosím platnou MAC adresu koncového zařízení, které se přejete aktivovat v síti Rychlý drát.")])])]) : _vm._e()]), _vm._v(" "), (_vm.devmeta.modified_recently) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        Změněno " + _vm._s(_vm.devmeta.modified_at) + ". Změna se projeví během 15 minut.\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.displayError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.displayError) + "\n      ")])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "d-md-none"
  }), _vm._v(" "), (!_vm.devmeta.isNew) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-2"
  }, [_c('nobr', [(_vm.publicAddress(_vm.devmeta.ip4addr)) ? _c('span', {
    staticClass: "badge badge-info",
    staticStyle: {
      "font-size": "100%"
    }
  }, [_vm._v("veřejná")]) : _vm._e(), _vm._v("\n          IP adresa:\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-4"
  }, [_c('span', {
    staticClass: "device-item-highlight"
  }, [_vm._v(_vm._s(_vm.devmeta.ip4addr))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDetails),
      expression: "!showDetails"
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showDetails = true
      }
    }
  }, [_vm._v("▾ podrobnosti ...")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.publicAddress(_vm.devmeta.ip4addr)) ? _c('span', {
    staticClass: "text-info"
  }, [_c('span', {
    staticClass: "d-none d-md-inline"
  }, [_vm._v("👈")]), _vm._v("\n          toto je Vaše veřejná IP adresa\n        ")]) : _vm._e()])]), _vm._v(" "), (_vm.devmeta.created_recently) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n          Přidáno " + _vm._s(_vm.devmeta.created_at) + ". Zařízení bude aktivní během 15 minut.\n        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetails),
      expression: "showDetails"
    }],
    staticClass: "alert alert-secondary"
  }, [_c('nobr', [_vm._v("Maska podsítě:")]), _vm._v(" "), _c('span', {
    staticClass: "device-item-highlight"
  }, [_vm._v(_vm._s(_vm.devmeta.netmask))]), _vm._v(" "), _c('nobr', [_vm._v("Výchozí brána:")]), _vm._v(" "), _c('span', {
    staticClass: "device-item-highlight"
  }, [_vm._v(_vm._s(_vm.devmeta.gateway))]), _vm._v(" "), _c('nobr', [_vm._v("DNS server 1:")]), _vm._v(" "), _c('span', {
    staticClass: "device-item-highlight"
  }, [_vm._v(_vm._s(_vm.devmeta.dns1))]), _vm._v(" "), _c('nobr', [_vm._v("DNS server 2:")]), _vm._v(" "), _c('span', {
    staticClass: "device-item-highlight"
  }, [_vm._v(_vm._s(_vm.devmeta.dns2))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.devmeta.ip6addr && _vm.devmeta.ip6enabled),
      expression: "devmeta.ip6addr && devmeta.ip6enabled"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-2"
  }, [_c('hr', {
    staticClass: "d-md-none"
  }), _vm._v(" "), _c('nobr', [_vm._v("\n          IP adresa\n          "), _c('span', {
    staticClass: "badge badge-info",
    staticStyle: {
      "font-size": "100%"
    }
  }, [_vm._v("v6")]), _vm._v(":\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-lg-10 device-item-highlight"
  }, [_vm._v(_vm._s(_vm.devmeta.ip6addr))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.devmeta.ip6prefix56 && _vm.devmeta.ip6enabled),
      expression: "devmeta.ip6prefix56 && devmeta.ip6enabled"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-2"
  }, [_c('hr', {
    staticClass: "d-md-none"
  }), _vm._v(" "), _c('nobr', [_vm._v("\n          IP subnet\n          "), _c('span', {
    staticClass: "badge badge-info",
    staticStyle: {
      "font-size": "100%"
    }
  }, [_vm._v("v6")]), _vm._v(":\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-4 device-item-highlight"
  }, [_vm._v(_vm._s(_vm.devmeta.ip6prefix56) + "/56")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.devmeta.ip6prefix56open) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n          ⚠️ Volitelná služba "), _c('b', [_vm._v("otevřený přístup do sítě")]), _vm._v(" je zapnutá. Všechny Vaše IP adresy v rozsahu " + _vm._s(_vm.devmeta.ip6prefix56) + "/56 jsou plně dostupné z celého světa.\n        ")])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 col-lg-6"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_vm._v("máte k dispozici 256 podsítí o velikosti /64")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c18cb7f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NetDevice.vue
// module id = 318
// module chunks = 1 2